import { render, staticRenderFns } from "./VirUploadImg.vue?vue&type=template&id=57b60e24&scoped=true"
import script from "./VirUploadImg.vue?vue&type=script&lang=ts"
export * from "./VirUploadImg.vue?vue&type=script&lang=ts"
import style0 from "./VirUploadImg.vue?vue&type=style&index=0&id=57b60e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b60e24",
  null
  
)

export default component.exports